import { AdminLayout, InstructorLayout, LandingPublicLayout } from "../layouts";
import { NotFound } from "../pages";
import { adminRoutes } from "./Admin";
import { instructorRoutes } from "./Instructor";
import { landingRoutes } from "./Landing";

/**
 * Generates an array of routes for the entire application.
 * @returns {Array} An array containing route objects for admin, user, and not-found pages.
 */
export const routes = () => {
  const adminRoutesConfig = {
    element: <AdminLayout />,
    children: [...adminRoutes()],
  };
  const instructorRoutesConfig = {
    element: <InstructorLayout />,
    children: [...instructorRoutes()],
  };
  const landingRoutesConfig = {
    element: <LandingPublicLayout />,
    children: [...landingRoutes()],
  };

  const notFoundRouteConfig = {
    path: "*",
    element: <NotFound />,
  };

  // Return an array containing all defined routes
  return [adminRoutesConfig,instructorRoutesConfig, notFoundRouteConfig,landingRoutesConfig];
};

/**
 * Generates a list of routes for the entire application.
 * @returns {Array} An array containing route objects for both admin and user sections.
 */
export const routesList = () => {
  // Retrieve the routes from user and admin sections
  const [adminRoutesConfig] = [adminRoutes()];
  const [instructorRoutesConfig] = [instructorRoutes()];
  const [landingRoutesConfig] = [landingRoutes()];

  // Concatenate the children arrays from both user and admin routes
  const routeArr = [
    ...adminRoutesConfig[0].children,
    ...adminRoutesConfig[1].children,
    ...instructorRoutesConfig[0].children,
    ...instructorRoutesConfig[1].children,
    ...landingRoutesConfig[0].children,
  ];

  return [...routeArr];
};

/**
 * Generates a list of module routes for both user and admin sections.
 * @returns {Object} An object containing route arrays for user and admin modules.
 */
export const moduleRoutesList = () => {
  let routeArr = {
    admin: [...adminRoutes()[0].children, ...adminRoutes()[1].children],
    instructor: [...instructorRoutes()[0].children, ...instructorRoutes()[1].children],
    landing : [...landingRoutes()[0].children],
  };
  return routeArr;
};

/**
 * Generates a list of complete paths from the application routes.
 * @returns {Array} An array containing complete path objects from both main and child routes.
 */
export const getCompletePathList = () => {
  return routesList().reduce((prev, curr) => {
    prev.push(curr);
    if (curr.children) {
      prev.push(...curr.children);
    }
    return prev;
  }, []);
};
